var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "purchase-outfit-container page-container" },
    [
      !_vm.dataLoading
        ? _c("purchase-outfit", {
            attrs: {
              outfitCurrent: _vm.currentOutfit,
              returnTitle: _vm.returnTitle,
              returnPath: _vm.returnPath
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dataLoading,
                expression: "dataLoading"
              }
            ],
            staticClass: "loading-overlay"
          },
          [_c("loader")],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-550b7407", { render: render, staticRenderFns: staticRenderFns })
  }
}